import React from 'react';
import styled from 'styled-components';
import MotifBreadcrumbItem from '@ey/motif-react-wrapper/BreadcrumbItem';

export default function BreadcrumbItem(props) {
	const {id, className, variant, icon, onClick, children} = props;
	return (
		<StyledMotifBreadcrumbItem id={id} className={className} variant={variant} icon={icon} onClick={onClick}>
			{children}
		</StyledMotifBreadcrumbItem>
	);
}

const StyledMotifBreadcrumbItem = styled(MotifBreadcrumbItem)``;
